import React, { useState } from "react";
import AirbnbHero from "./AirbnbHero";
import Header from "../Header/header";
import Footer from "../footer";
import AirbnbBody from "./AirbnbBody";
import QuoteModal from "../quoteModal";

export default function Airbnb(props) {
  const { openproductModal, isproductModalOpen } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div>
        <Header openproductModal={openproductModal} isproductModalOpen={isproductModalOpen} />
        <QuoteModal isOpen={isModalOpen} closeModal={closeModal} />
        <AirbnbHero openModal={openModal} />
        <AirbnbBody openModal={openModal} />
        <Footer />
      </div>
    </div>
  );
}
